module.exports = __webpack_public_path__ + "img/5a8051d.jpg";